"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = __importStar(require("react"));

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var Popover_1 = require("./Popover");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var ToolTipIcon = (0, styled_1.default)(frontend_assets_1.Icon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tcursor: pointer;\n"])));
var TooltipContainer = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: inline-flex;\n"])));

var tooltipContentWrapper = function tooltipContentWrapper(props) {
  return (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tbackground-color: ", ";\n\tpadding: 10px;\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n\t@media only screen and (min-width: ", ") {\n\t\twidth: 200px;\n\t}\n"])), props.background, props.breakpoint);
};

var Tooltip = function Tooltip(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "help" : _ref$icon,
      _ref$isIconCircled = _ref.isIconCircled,
      isIconCircled = _ref$isIconCircled === void 0 ? false : _ref$isIconCircled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      hoverColor = _ref.hoverColor,
      children = _ref.children,
      handleTooltipChange = _ref.handleTooltipChange;
  var bodyRef = (0, react_2.useRef)(null);
  var popperRef = react_2.default.useRef(null);

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, react_2.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      showTooltipContent = _ref4[0],
      setShowTooltipContent = _ref4[1];

  var _ref5 = (0, frontend_common_1.useWindowSize)(),
      _ref6 = _slicedToArray(_ref5, 1),
      windowWidth = _ref6[0];

  var isMobile = windowWidth < parseInt(theme.breakpoints.lg);
  (0, react_2.useEffect)(function () {
    handleTooltipChange && handleTooltipChange(showTooltipContent);
  }, [showTooltipContent]);

  var fallBackClose = function fallBackClose() {
    var _a;

    !!showTooltipContent && setShowTooltipContent(false);
    (_a = popperRef.current) === null || _a === void 0 ? void 0 : _a.close();
  };

  return (0, jsx_runtime_1.jsx)(react_2.default.Fragment, {
    children: (0, jsx_runtime_1.jsx)(TooltipContainer, {
      tabIndex: 0,
      css: {
        borderColor: theme.colors[type].background
      },
      children: (0, jsx_runtime_1.jsx)(Popover_1.Popover, {
        ref: popperRef,
        onClose: function onClose() {
          return setShowTooltipContent(false);
        },
        onOpen: function onOpen() {
          return setShowTooltipContent(true);
        },
        alignment: isMobile ? "auto" : "bottom-start",
        offset: [0, 7],
        hover: !isMobile ? true : false,
        popoverType: "caret",
        caretColor: theme.colors[type].background,
        trigger: (0, jsx_runtime_1.jsx)("div", {
          css: {
            paddingTop: 1
          },
          onMouseLeave: function onMouseLeave() {
            return fallBackClose();
          },
          children: (0, jsx_runtime_1.jsx)(ToolTipIcon, {
            icon: icon,
            circled: isIconCircled,
            size: size,
            hoverColor: hoverColor
          })
        }),
        children: (0, jsx_runtime_1.jsx)("div", {
          css: {
            pointerEvents: "none"
          },
          onMouseLeave: function onMouseLeave() {
            return fallBackClose();
          },
          onMouseOver: function onMouseOver() {
            return fallBackClose();
          },
          onMouseEnter: function onMouseEnter() {
            return fallBackClose();
          },
          children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            style: tooltipContentWrapper({
              breakpoint: theme.breakpoints.lg,
              background: theme.colors[type].background
            }),
            itemRef: bodyRef,
            justifyContent: "space-between",
            className: "tooltipContentWrapper",
            children: children
          })
        })
      })
    })
  });
};

exports.Tooltip = Tooltip;